import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import CurrencyInput from 'react-currency-input-field';
import { th } from 'style/theme';

const StyledCurrencyInput = styled(CurrencyInput)`
  width: 100%;
  margin-top: 8px;
  padding-bottom: 3px;
  padding-left: 0;
  border-radius: 0;
  font-size: 16px;
  background-color: transparent;
  color: ${th('colors.black')};
  border-bottom: 1px solid ${th('colors.black')};

  ::placeholder {
    color: ${th('colors.black')};
    opacity: 0.5;
    font-style: italic;
  }
`;

const MoneyInput = ({ name, onChange, value, placeholder }) => {
  return (
    <StyledCurrencyInput
      name={name}
      decimalsLimit={2}
      decimalScale={2}
      decimalSeparator="."
      groupSeparator=","
      onValueChange={onChange}
      value={value}
      placeholder={placeholder}
    />
  );
};

MoneyInput.propTypes = {
  name: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  placeholder: PropTypes.string
};

export default MoneyInput;
